import { Dialog, DialogContent, DialogContentProps, DialogProps as MuiDialogProps } from '@mui/material';
import React, { FunctionComponent } from 'react';

export interface DialogProps {
  onClose: () => void;
  isOpen: boolean;
  closeOnDialogClick?: boolean;
  sx?: MuiDialogProps['sx'];
  contentSx?: DialogContentProps['sx'];
  maxWidth?: MuiDialogProps['maxWidth'];
  fullWidth?: MuiDialogProps['fullWidth'];
}

const BasicDialog: FunctionComponent<React.PropsWithChildren<DialogProps>> = ({
  children,
  onClose,
  isOpen,
  closeOnDialogClick = true,
  sx,
  contentSx,
  maxWidth = 'md',
  fullWidth = false,
}) => {
  return isOpen ? (
    <Dialog
      onClick={(e) => {
        if (closeOnDialogClick) {
          onClose(); // close dialog when click outside of dialog content
        }
        e.stopPropagation();
      }}
      open={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      sx={sx}
      fullWidth={fullWidth}
    >
      <DialogContent
        onClick={(e) => {
          e.stopPropagation(); // prevent the click from propagating to the parent to make the dialog stay open
        }}
        sx={contentSx}
      >
        {children}
      </DialogContent>
    </Dialog>
  ) : null;
};

export default BasicDialog;
